
import { mapState, mapGetters } from "vuex";
import VideoItem from "~/components/v2/video-item.vue";
import { mdiCheck } from "@mdi/js";

function getDescription(video) {
  const profile = video?.profile;
  if (!profile) return;

  const name = profile.name;
  const age = profile.age;
  const city = profile.city;

  return `Meet ${name}, a stunning escort at ${age} years old. Available in ${city}, ${name} brings elegance and charm to every encounter, making your time unforgettable.`;
}

export default {
  name: "VideoBank",

  components: {
    VideoItem,
  },

  data() {
    return {
      route: this.$route.name,
      dataBackground: "",
      filterModalSsOpen: false,
      loading: false,
      mdiCheck,

      gender: [],
      district: "",
    };
  },

  async fetch() {
    this.gender = this.$store.getters["global/getCurrentGender"] || "female";
    this.$store.commit("video-gallery/setFilter", {
      key: "gender",
      value: this.gender,
    });
    await this.$store.dispatch("video-gallery/retrieveAllVideos", {
      page: this.$route.query.page || 1,
      reset: true,
    });
  },

  head() {
    return {
      title: this.processedSeoTexts?.title || "Emirates Video Bank",

      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/escorts-videos`,
        },
      ],

      meta: [
        {
          hid: "description",
          name: "description",
          content: this.processedSeoTexts?.description || "",
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.processedSeoTexts?.description || "",
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.processedSeoTexts?.title || "Emirates Video Bank",
        },
        {
          property: "og:image",
          hid: "og:image",
          name: "og:image",
          content: "https://erowall.com/wallpapers/large/3156.jpg",
        },
      ],

      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.jsonld),
        },
      ],

      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    ...mapState(["profiles", "viewedModels", "menus"]),

    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      videos: "video-gallery/getAllVideos",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      processedSeoTexts: "global/getProcessedSeoTexts",
      page: "video-gallery/getPage",
      lastPage: "video-gallery/getLastPage",
      total: "video-gallery/getTotal",
    }),

    h1() {
      return this.processedSeoTexts?.h1 || this.$t("video-bank");
    },

    isMobile() {
      return this.$store.state.global.mobile;
    },

    openCatalogFilter() {
      return this.$store.state.catalog.catalogFilter;
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];

      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
        gender: {
          items: [
            { title: this.$t("female"), id: "female" },
            { title: this.$t("shemale"), id: "transgender" },
            { title: this.$t("male"), id: "male" },
          ],
          title: this.$t("gender"),
        },
      };
    },

    districtsDroplist() {
      return [
        ...[
          {
            title: this.$t("all-areas"),
            value: "",
          },
        ],
        ...(this.filterObj.district.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []),
      ];
    },

    genderDroplist() {
      return (
        this.filterObj.gender.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []
      );
    },

    percentage() {
      return (this.videos.length * 100) / this.total;
    },

    isPageQuery() {
      return this.$route.query.page;
    },

    jsonld() {
      return {
        "@context": "https://schema.org",
        "@graph": this.videos.map((video) => {
          return {
            "@type": "VideoObject",
            name: video?.seo?.name,
            description: getDescription(video) || video?.seo?.description,
            thumbnailUrl: video?.seo?.thumbnailUrl,
            uploadDate: video?.seo?.uploadDate,
            contentUrl: video?.seo?.contentUrl,
            embedUrl: video?.seo?.embedUrl,
          };
        }),
      };
    },
  },

  beforeDestroy() {
    this.$store.commit("video-gallery/resetFilters");
  },

  methods: {
    showMoreProfiles() {
      this.inDefaultView += this.perView;
    },

    async setFilter(key, option) {
      const value = option.value ? option.value : "";
      this.$store.commit("video-gallery/setFilter", { key, value });
      await this.$store.dispatch("video-gallery/retrieveAllVideos", {
        reset: true,
      });
    },

    async setFilterMobile(data) {
      for (let key in data) {
        const value = data[key];
        if (value) {
          this.$store.commit("video-gallery/setFilter", { key, value });
        }
      }
    },

    redirectOnAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    videoFilterModal() {
      this.$store.commit("global/setVideoFilterModal");
    },

    // async showMoreVideos() {
    //   this.loading = true;

    //   await this.$store.dispatch("video-gallery/retrieveAllVideos", {
    //     page: this.page + 1,
    //   });

    //   this.loading = false;
    // },

    // async loadMore() {
    //   if (this.page >= this.lastPage || this.loading || this.isPageQuery)
    //     return;

    //   await this.showMoreVideos();
    // },

    async nextPage() {
      if (this.page >= this.lastPage || this.loading) return;
      this.loading = true;
      this.$router.push({
        name: this.$route.name,
        query: { page: this.page + 1 },
      });

      await this.$store.dispatch("video-gallery/retrieveAllVideos", {
        page: this.page + 1,
        reset: true,
      });

      this.loading = false;

      this.scrollToTop();
    },

    async previousPage() {
      if (this.loading || this.page == 1) return;
      this.loading = true;

      this.$router.push({
        name: this.$route.name,
        query: { page: this.page - 1 },
      });

      await this.$store.dispatch("video-gallery/retrieveAllVideos", {
        page: this.page - 1,
        reset: true,
      });

      this.loading = false;

      this.scrollToTop();
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    async onFilterChange(value, key) {
      this.$store.commit("video-gallery/setFilter", { key, value });
      await this.$store.dispatch("video-gallery/retrieveAllVideos", {
        reset: true,
      });
    },
  },
};
